<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="role-dialog" width="350px">
		<span slot="title" class="dialog-title">
			<span>{{ title }}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-position="top" ref="dataForm">
			<el-form-item label="角色名称" prop="name">
				<el-input v-model="dataForm.name" placeholder="角色名称" maxlength="32" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="角色类型" prop="type">
				<el-select v-model="dataForm.type" filterable :disabled="readonly">
					<el-option v-for="(item, i) in roleTypeList" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="isMaintenanceRole || isLogisticsRole || isDataAuditRole" label="关联" prop="roleDeviceList" :rules="roleDeviceListRule">
				<el-select v-model="dataForm.roleDeviceList" multiple clearable :disabled="readonly">
					<template v-if="isMaintenanceRole">
						<el-option v-for="(option, i) in repairApprovalMachineOptions" :key="i" :value="option.id" :label="option.name"></el-option>
					</template>
					<template v-else-if="isLogisticsRole">
						<el-option v-for="(option, i) in logisticsMachineOptions" :key="i" :value="option.id" :label="option.name"></el-option>
					</template>
					<template v-else-if="isDataAuditRole">
						<el-option v-for="(option, i) in dataAuditMachineOptions" :key="i" :value="option.id" :label="option.name"></el-option>
					</template>
				</el-select>
			</el-form-item>
			<el-form-item v-if="dataForm.type == '12'" label="关联角色(多选)" prop="realRoleIdList">
				<el-select
					v-model="dataForm.realRoleIdList"
					:disabled="readonly"
					multiple
					filterable
					remote
					reserve-keyword
					:remote-method="remoteSearchRole"
					:loading="roleLoading">
					<el-option v-for="(item, i) in roleList" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="技能等级(多选)" prop="realSkillIdList" v-if="dataForm.type == '12'">
				<el-select placeholder="请选择技能等级" v-model="dataForm.realSkillIdList" multiple :disabled="readonly">
					<el-option v-for="(item, i) in skillIdList" :key="i" :value="item.id" :label="item.skillName"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="dataForm.type == '12'" label="公司范围" prop="agentScope">
				<el-select v-model="dataForm.agentScope" filterable :disabled="readonly">
					<el-option v-for="(item, i) in agentScopeList" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="dataForm.agentScope == 'MULTI'" label="公司选择(多选)" prop="realAgentIdList">
				<el-select
					v-model="dataForm.realAgentIdList"
					:disabled="readonly"
					multiple
					filterable
					remote
					reserve-keyword
					:remote-method="remoteSearchCompany"
					:loading="companyLoading">
					<el-option v-for="(item, i) in companyList" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="角色描述" prop="remark">
				<el-input v-model="dataForm.remark" placeholder="角色描述" maxlength="128" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="业务类型" prop="roleBsis">
				<el-select placeholder="请选择业务类型" v-model="dataForm.roleBsis" multiple :disabled="readonly">
					<el-option v-for="(item, i) in listCodes" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button v-if="!readonly" class="submit-btn" @click="submit">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from "@/utils/debounce";
import { repairApprovalMachineOptions, logisticsMachineOptions, dataAuditMachineOptions } from "@/constant/options";
import {courseSkillList, sysRolePage} from "@/api/skill";
export default {
	data() {
		return {
			title: "新增角色",
			visible: false,
			readonly: false,
			roleTypeList: [
				{
					id: 1,
					name: "超级管理员",
				},
				{
					id: 2,
					name: "管理员",
				},
				{
					id: 3,
					name: "普通成员",
				},
				{
					id: 4,
					name: "学员",
				},
				{
					id: 5,
					name: "经销商",
				},
				{
					id: 6,
					name: "教师",
				},
				{
					id: 7,
					name: "维修审批",
				},
				{
					id: 8,
					name: "索赔管理",
				},
				{
					id: 9,
					name: "索赔物流",
				},
				{
					id: 10,
					name: "物流审批",
				},
				{
					id: 11,
					name: "资料审核",
				},
				{
					id: 12,
					name: "技能信息",
				},
			],
			agentScopeList: [
				{
					id: "SELF",
					name: "所属公司",
				},

				{
					id: "ALL",
					name: "所有公司",
				},

				{
					id: "MULTI",
					name: "多公司",
				},
			],
			// 角色类型为维修审批时的可审批机型
			repairApprovalMachineOptions,
			logisticsMachineOptions,
			dataAuditMachineOptions,
			dataForm: {
				name: "",
				type: "",
				remark: "",
				roleDeviceList: [],
				roleBsis: [],
				realRoleIdList: [], //关联角色信息
				agentScope: "", //公司范围：所属公司 SELF /   所有公司  ALL   /   多公司 MULTI
				realAgentIdList: [], //关联公司信息
				realSkillIdList: [], //关联技能信息
			},
			submitUrl: "sysRoleAdd",
			dataRule: {
				name: [{ required: true, message: "角色名称不能为空", trigger: "blur" }],
				type: [{ required: true, message: "请选择角色类型", trigger: "change" }],
				roleBsis: [{ required: true, message: "请选择业务类型", trigger: "change" }],
				realRoleIdList: [{ required: true, message: "请选择关联角色", trigger: "change" }],
				agentScope: [{ required: true, message: "请选择公司范围", trigger: "change" }],
				realAgentIdList: [{ required: true, message: "请选择公司", trigger: "change" }],
				realSkillIdList: [{ required: true, message: "请选择技能等级", trigger: "change" }],
			},
			roleDeviceListRule: [{ required: true, message: "请选择关联数据", trigger: "change" }],
			listCodes: [],
			roleLoading: false, // 角色搜索loading状态
			roleList: [], // 角色列表
			companyLoading: false,
			companyList: [],
			skillIdList: [], // 技能ID列表
		};
	},
	computed: {
		isMaintenanceRole() {
			// 是否为[维修审批]角色
			return this.dataForm.type === 7 || this.dataForm.type === "7";
		},
		isLogisticsRole() {
			// 是否为[索赔物流]或[物流审批]角色
			return this.dataForm.type === 9 || this.dataForm.type === "9" || this.dataForm.type === 10 || this.dataForm.type === "10";
		},
		isDataAuditRole() {
			// 是否为[资料审核]角色
			return this.dataForm.type === 11 || this.dataForm.type === "11";
		},
	},
	methods: {
		init(type, data) {
			this.visible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				this.getListByCodes();
				if (type == "add") {
					this.title = "新增角色";
					this.submitUrl = "sysRoleAdd";
					this.readonly = false;
					delete this.dataForm.id;
					this.dataForm.type = "";
					this.dataForm.agentScope = "";
					this.dataForm.realAgentIdList = [];
					this.dataForm.realRoleIdList = [];
					this.dataForm.realSkillIdList = [];
					this.getRoleList("");
					this.getDealerList("");
					this.getSkillList();
				} else if (type == "edit") {
					this.title = "修改角色";
					this.dataForm.type = data.type;
					this.dataForm.name = data.name;
					this.dataForm.remark = data.remark;
					if (data.roleDeviceList && data.roleDeviceList.length > 0) {
						this.dataForm.roleDeviceList = data.roleDeviceList.map((item) => {
							return item.deviceType;
						});
					} else {
						this.dataForm.roleDeviceList = [];
					}
					this.dataForm.roleBsis = data.roleBsi.split(",");
					this.dataForm.id = data.id;
					this.submitUrl = "sysRoleUpdate";
					this.readonly = false;
					this.dataForm.agentScope = data.agentScope;
					this.dataForm.realAgentIdList = data.realAgentList.map((item) => item.agentId);
					this.dataForm.realRoleIdList = data.realRoleList.map((item) => item.relRoleId);
					this.dataForm.realSkillIdList = data.realSkillList.map((item) => item.skillId);
					this.getDealerList("", this.dataForm.realAgentIdList.join(","));
					this.getRoleList(this.dataForm.realRoleIdList.join(","));
					this.getSkillList();
				} else {
					this.title = "查看角色";
					this.dataForm.type = data.type;
					this.dataForm.name = data.name;
					this.dataForm.remark = data.remark;
					if (data.roleDeviceList && data.roleDeviceList.length > 0) {
						this.dataForm.roleDeviceList = data.roleDeviceList.map((item) => {
							return item.deviceType;
						});
					} else {
						this.dataForm.roleDeviceList = [];
					}
					this.dataForm.roleBsis = data.roleBsi.split(",");
					this.submitUrl = "sysRoleUpdate";
					this.readonly = true;
					this.dataForm.agentScope = data.agentScope;
					this.dataForm.realAgentIdList = data.realAgentList.map((item) => item.agentId);
					this.dataForm.realRoleIdList = data.realRoleList.map((item) => item.relRoleId);
					this.dataForm.realSkillIdList = data.realSkillList.map((item) => item.skillId);
					this.getDealerList("", this.dataForm.realAgentIdList.join(","));
					this.getRoleList(this.dataForm.realRoleIdList.join(","));
					this.getSkillList();
				}
			});
		},
		getListByCodes() {
			// 获取故障相关的字典数据
			let self = this;
			const params = {
				codes: "roleBsi",
			};
			self.$request.post(
				"getListByCodes",
				false,
				params,
				function (r) {
					if (r.code == "0") {
						self.listCodes = r.data.roleBsi;
					} else {
						self.$message.error(r.msg);
					}
				},
				function () {},
			);
		},
		remoteSearchRole(query) {
			// 清空搜索时返回空
			if (query == "") {
				return;
			}
			this.roleLoading = true;
			sysRolePage({
				searchKey: query,
				page: 1,
				pageSize: 20,
			}).then((res) => {
				const searchList = res.data?.list || [];

				// 保留已选中的选项，防止 label 丢失，同时排除当前角色
				const selectedItems = this.roleList.filter((item) => this.dataForm.realRoleIdList.includes(item.id) && item.id !== this.dataForm.id);

				// 合并已选项 + 搜索结果（去重），并排除当前角色
				const selectedIds = selectedItems.map((item) => item.id);
				const newItems = searchList.filter((item) => !selectedIds.includes(item.id) && item.id !== this.dataForm.id);

				this.roleList = [...selectedItems, ...newItems];
				this.roleLoading = false;
			});
		},
		getRoleList(ids) {
			sysRolePage({
				page: 1,
				pageSize: 20,
				ids: ids,
			}).then((res) => {
				this.roleList = (res.data?.list || []).filter((item) => item.id !== this.dataForm.id);
			});
		},
		// 获取技能数据
		getSkillList() {
			courseSkillList({}).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.skillIdList = res.data
			});
		},
		// 获取经销商数据
		getDealerList(searchKey, ids) {
			this.companyLoading = true;
			let self = this;
			self.$request.post(
				"getDealerLists",
				false,
				{
					searchKey: searchKey,
					ids: ids,
				},
				function (r) {
					if (r.code == "0") {
						if (searchKey == "") {
							self.companyList = r.data;
						} else {
							const searchList = r.data || [];
							// 保留已选中的选项，防止 label 丢失
							const selectedItems = self.companyList.filter((item) => self.dataForm.realAgentIdList.includes(item.id));

							// 合并已选项 + 搜索结果（去重）
							const selectedIds = selectedItems.map((item) => item.id);
							const newItems = searchList.filter((item) => !selectedIds.includes(item.id));

							self.companyList = [...selectedItems, ...newItems];
						}
					} else {
						self.$message.error(r.msg);
					}
					self.companyLoading = false;
				},
			);
		},
		remoteSearchCompany(query) {
			if (query == "") {
				return;
			}
			this.getDealerList(query);
		},
		submit: debounce(function () {
			if (this.visible == false) {
				return;
			}
			this.$refs["dataForm"].validate((valid) => {
				if (valid) {
					let self = this;
					if (self.dataForm.type == "12") {
						if (self.dataForm.agentScope != "MULTI") {
							self.dataForm.realAgentIdList = [];
						}
					} else {
						self.dataForm.realRoleIdList = [];
						self.dataForm.realAgentIdList = [];
						self.dataForm.agentScope = "";
					}
					const data = JSON.parse(JSON.stringify(self.dataForm));
					data.roleDeviceList = data.roleDeviceList.map((item) => {
						return { deviceType: item };
					});
					data.roleBsi = data.roleBsis.join(",");
					delete data.roleBsis;
					self.$request.post(self.submitUrl, true, data, function (r) {
						if (r.code == "0") {
							self.visible = false;
							self.$emit("getRoleList");
							self.$message.success("保存成功");
						} else {
							self.$message.error(r.msg);
						}
					});
				} else {
					return false;
				}
			});
		}, 1000),
	},
};
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;
	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}
.el-form-item {
	margin-bottom: 10px;
	.el-select {
		width: 100%;
	}
}
.submit-btn {
	width: 100%;
	background-color: #117ffc;
	color: #fff;
}
.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}
.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}
.role-dialog /deep/ .el-form-item__label {
	padding: 0 !important;
}
.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 40px !important;
}
</style>
